import { clientEnv } from "@/env/client";
import type { Database } from "@/utils/supabase/types";
import { createBrowserClient } from "@supabase/ssr";

const createClient = () =>
  createBrowserClient<Database>(
    clientEnv.NEXT_PUBLIC_SUPABASE_URL,
    clientEnv.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  );

const browserClient = createClient();
export const useBrowserClient = () => {
  return browserClient;
};
